import { useMemo } from 'react';
import { t } from '../../lang';
import Icon, { Icons } from '../Icon/Icon';
import './AMLRiskIndicator.scss';

const AMLRiskIndicator = ({ percent = 0, indicatorColor = 'rgba(var(--AML-low), 1)', isUnverified = false }) => {
	const formatPercentForDisplay = value => {
		const roundedTo2 = Math.round(value * 100) / 100;
		const isWholeNumber = Math.abs(roundedTo2 - Math.round(roundedTo2)) < 1e-9;

		return isWholeNumber ? String(Math.round(roundedTo2)) : roundedTo2.toFixed(2);
	};

	const iconColor = useMemo(() => {
		if (Math.abs(percent - 100) < 0.01) return 'rgba(var(--AML-high), 1)';
		return 'rgba(var(--grey5), 1)';
	}, [percent]);

	return (
		<div
			className='AMLRiskIndicator'
			style={{ '--color': indicatorColor, ...(iconColor ? { '--icon-color': iconColor } : {}) }}
		>
			{isUnverified ? (
				<div className='AMLRiskIndicator_unverified'>
					<div className='AMLRiskIndicator_unverified_title'>{t('Unverified')}</div>
					<div className='AMLRiskIndicator_unverified_subtitle'>
						{t('This address hasnt appeared in any known AML records — flagged or otherwise.')}
					</div>
				</div>
			) : (
				<div className='AMLRiskIndicator_percent'>{formatPercentForDisplay(percent)}%</div>
			)}

			<div className='AMLRiskIndicator_progress'>
				<div className='AMLRiskIndicator_progress_background' />
				{!isUnverified && (
					<div className='AMLRiskIndicator_progress_filling' style={{ '--percent': `${percent}%` }}>
						<div className='AMLRiskIndicator_progress_filling_glare' />
					</div>
				)}
				<Icon className='AMLRiskIndicator_progress_icon' type={Icons.AML_FIRE} width={50} height={60} />
			</div>
		</div>
	);
};

export default AMLRiskIndicator;
